module.exports = __webpack_public_path__ + "operace-nosu_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_1_before.jpg
// module id = 1130
// module chunks = 0